export const ACCESS_POINT_TYPE = "accessPoint";
export const BATTERY_TYPE = "battery";
export const DOCK_TYPE = "dock";
export const VEHICLE_TYPE = "vehicle";
export const GIMBAL_TYPE = "gimbal";
export const ATTACHMENT_TYPE = "attachment";
export const DEVICE_TYPES = [
  VEHICLE_TYPE,
  DOCK_TYPE,
  BATTERY_TYPE,
  ACCESS_POINT_TYPE,
  GIMBAL_TYPE,
  ATTACHMENT_TYPE,
] as const;
export type DeviceType = (typeof DEVICE_TYPES)[number];
export type IOTDeviceType = Exclude<DeviceType, "battery" | "gimbal" | "attachment">;

// mobile responsive breakpoints
// https://ant.design/components/layout/#breakpoint-width
// also based on bootstrap breakpoint widths
export const BREAKPOINT_WIDTH_XS = 480;
export const BREAKPOINT_WIDTH_SM = 576;
export const BREAKPOINT_WIDTH_MD = 768;
export const BREAKPOINT_WIDTH_LG = 992;
export const BREAKPOINT_WIDTH_XL = 1200;
export const BREAKPOINT_WIDTH_XXL = 1600;

// NOTE(jeremys): These constants may become invalid if the email or db entry for the generic user
// ever changes. Use these constants only in contexts where they are not exposed to customers
// and where their change or removal would not be critical to functionality. Possible use cases might
// be internal facing or low-priority features until a more dynamic solution is implemented.
export const GENERIC_SKYDIO_UNKNOWN_VEHICLE_USER_EMAIL = "unknown_user@vehicle.skyd.io";
export const GENERIC_SKYDIO_UNKNOWN_VEHICLE_USER_ID =
  "VXNlcjo5NTE5MDM2MC05Y2JhLTQxMDgtOGI3NC1iNjQzMGQ4ZWJkZGE";
export const GENERIC_SKYDIO_UNKNOWN_VEHICLE_USER_UUID = "95190360-9cba-4108-8b74-b6430d8ebdda";
